import { render, staticRenderFns } from "./ContiguityList.vue?vue&type=template&id=9f5402d2&scoped=true&"
import script from "./ContiguityList.vue?vue&type=script&lang=js&"
export * from "./ContiguityList.vue?vue&type=script&lang=js&"
import style0 from "./ContiguityList.vue?vue&type=style&index=0&id=9f5402d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5402d2",
  null
  
)

export default component.exports